export const sanitiseToOnlyAlphanumeric = (value: string | undefined) => {
    return value?.replace(/[^a-zA-Z0-9 ]/g, '');
};
